import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "../shared/general/Header";
import ApplicantReviewForm from "./ApplicantReviewForm";
import Footer from "../shared/general/Footer";

const ApplicantReview = () => (
  <Router>
    <Header />
    <Switch>
      <Route
        exact
        path="/applicant_reviews/:id"
        component={ApplicantReviewForm}
      />
    </Switch>
    <Footer />
  </Router>
);

export default ApplicantReview;
